module.exports = __webpack_public_path__ + "static/media/snapshot-sample3.11c937eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ittybittyapps/snapshot-sample3.png
// module id = 185
// module chunks = 0